export class SendViaApiFieldMapping {
  public ApiFieldName: string;
  public ContactFieldName: string;
  
  constructor(init: any) {
    this.ApiFieldName = init.ApiFieldName;
    this.ContactFieldName = init.ContactFieldName;    
  }
}